import React, { useState, useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    FormControl,
    FormLabel,
    FormErrorMessage,
    Stack,
    useToast,
    Select
} from '@chakra-ui/react';

const EditTeamMemberModal = ({ isOpen, onClose, member, onSave }) => {
    const toast = useToast();
    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        email: '',
        bookingPhone: '',
        role: ''
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (member) {
            setFormData({
                name: member.name || '',
                surname: member.surname || '',
                email: member.email || '',
                bookingPhone: member.bookingPhone || '',
                role: member.role || ''
            });
        }
    }, [member]);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({ ...prev, [id]: value }));

        setErrors(prev => {
            const updated = { ...prev };
            if (value.trim()) delete updated[id];
            return updated;
        });
    };
    const handleSubmit = async () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = true;
        if (!formData.surname) newErrors.surname = true;
        if (!formData.bookingPhone) newErrors.bookingPhone = true;
        if (!formData.email.includes('@')) newErrors.email = true;
        if (!formData.role) newErrors.role = true;

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            toast({
                title: 'Please fill all required fields.',
                status: 'error',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            });
            return;
        }

        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/update-team-member/${member.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    name: formData.name,
                    surname: formData.surname,
                    bookingEmail: formData.email,
                    bookingPhone: formData.bookingPhone || '', // якщо не редагується
                    roleName: formData.role
                })
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Update failed');

            toast({
                title: 'Team member updated.',
                status: 'success',
                variant: 'left-accent',
                duration: 3000,
                isClosable: true
            });

            onSave();
        } catch (err) {
            toast({
                title: 'Update failed.',
                description: err.message,
                status: 'error',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            });
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="md" zIndex={99995}>
            <ModalOverlay />
            <ModalContent p={6} bg="white" containerProps={{ zIndex: '99995' }}>
                <ModalHeader>Edit Team Member</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Stack spacing={4}>
                        <FormControl id="name" isInvalid={errors.name}>
                            <FormLabel>Name</FormLabel>
                            <Input value={formData.name} onChange={handleChange} />
                            {errors.name && <FormErrorMessage>Required</FormErrorMessage>}
                        </FormControl>
                        <FormControl id="surname" isInvalid={errors.surname}>
                            <FormLabel>Surname</FormLabel>
                            <Input value={formData.surname} onChange={handleChange} />
                            {errors.surname && <FormErrorMessage>Required</FormErrorMessage>}
                        </FormControl>
                        <FormControl id="email" isInvalid={errors.email}>
                            <FormLabel>Email</FormLabel>
                            <Input type="email" value={formData.email} onChange={handleChange} />
                            {errors.email && <FormErrorMessage>Invalid email</FormErrorMessage>}
                        </FormControl>
                        <FormControl id="bookingPhone" isInvalid={errors.bookingPhone}>
                            <FormLabel>booking Phone</FormLabel>
                            <Input value={formData.bookingPhone} maxLength={11} onChange={handleChange} />
                            {errors.bookingPhone && <FormErrorMessage>Required</FormErrorMessage>}
                        </FormControl>
                        <FormControl id="role" isInvalid={errors.role}>
                            <FormLabel>Role</FormLabel>
                            <Select value={formData.role} onChange={handleChange}>
                                <option value="admin">Admin</option>
                                <option value="member">Member</option>
                            </Select>
                            {errors.role && <FormErrorMessage>Required</FormErrorMessage>}
                        </FormControl>
                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={handleSubmit} variant="solid-green-btn" fontWeight={600}>
                        Save
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default EditTeamMemberModal;
